import { render, staticRenderFns } from "./DepositAndWithdrawal.vue?vue&type=template&id=aa145f84&scoped=true"
import script from "./DepositAndWithdrawal.vue?vue&type=script&scoped=true&lang=js"
export * from "./DepositAndWithdrawal.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./DepositAndWithdrawal.vue?vue&type=style&index=0&id=aa145f84&prod&scoped=true&lang=css"
import style1 from "./DepositAndWithdrawal.vue?vue&type=style&index=1&id=aa145f84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa145f84",
  null
  
)

export default component.exports